import React from 'react';
import classNames from 'classnames';

import styles from './Alert.module.scss';
import IconCheckTick from 'src/components/icons/IconCheckTick';
import IconInfo from "src/components/icons/IconInfo";

const variantIcon = {
    success: <IconCheckTick/>,
    info: <IconInfo/>,
};

export const Alert = ({variant, icon = null, children, action = null, className, ...props}) => {
    return (
        <div className={classNames(styles.alert, icon && styles.hasicon, action && styles.hasaction, variant && styles[`variant-${variant}`], className)} {...props}>
            {icon && <div className={styles.icon}>
                {variantIcon[variant]}
            </div>}
            <div className={styles.content}>
                {children}
            </div>
            {action && <div className={styles.action}>{action}</div>}
        </div>
    );
};
